import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "XjCrmUser"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "开通套餐", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "投诉处理", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "查看详情", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "取消体验", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "取消计费", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_avue_crud = _resolveComponent("avue-crud")!
  const _component_ChaKanXiangQing = _resolveComponent("ChaKanXiangQing")!
  const _component_ChaKanTouSu = _resolveComponent("ChaKanTouSu")!

  return (_ctx.init)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_avue_crud, {
          ref: "crud",
          data: _ctx.data.data,
          option: _ctx.option,
          page: _ctx.page,
          "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
          onRowSave: _ctx.rowSave,
          onOnLoad: _ctx.changePage,
          onRowUpdate: _ctx.rowUpdate,
          onSearchChange: _ctx.searchChange
        }, _createSlots({
          menu: _withCtx(({row}) => [
            (row.orderId > 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  text: "",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.SetTouSu(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Notification)
                      ]),
                      _: 1
                    }),
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (row.orderId > 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  text: "",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.SetXiangQing(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Notification)
                      ]),
                      _: 1
                    }),
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (row.orderId < 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  text: "",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.rowDel(row)),
                  style: _normalizeStyle({ display: row.status=='退订'?'none':'' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Warning)
                      ]),
                      _: 1
                    }),
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick", "style"]))
              : _createCommentVNode("", true),
            (row.orderId >= 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 3,
                  text: "",
                  type: "primary",
                  onClick: ($event: any) => (_ctx.XjCrmUserRemove(row)),
                  style: _normalizeStyle({ display: row.status=='退订'?'none':'' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Warning)
                      ]),
                      _: 1
                    }),
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick", "style"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.option.searchAddBtn)
            ? {
                name: "search-menu",
                fn: _withCtx(({size}) => [
                  _createVNode(_component_el_button, {
                    size: size,
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.crud.rowAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      }),
                      _hoisted_2
                    ]),
                    _: 2
                  }, 1032, ["size"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["data", "option", "page", "onRowSave", "onOnLoad", "onRowUpdate", "onSearchChange"]),
        _createVNode(_component_ChaKanXiangQing, {
          dialogFormVisible: _ctx.xiangqingDialogVisible,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.xiangqingDialogVisible=false)),
          ref: "ChaKanXiangQingRef"
        }, null, 8, ["dialogFormVisible"]),
        _createVNode(_component_ChaKanTouSu, {
          dialogFormVisible: _ctx.tousuDialogVisible,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tousuDialogVisible=false)),
          ref: "ChaKanTouSuRef"
        }, null, 8, ["dialogFormVisible"])
      ]))
    : _createCommentVNode("", true)
}